import * as React from 'react';
import {
  FormControl
} from '@mui/material';
import CardTemplate from './CardTemplate';
import { CategoryManager } from './CategoryManager'

export default function AddTagsCard(props: any) {
  const title = "Add tags";
  const subtitle = "Select tags that best match why the post isn’t safe. A self-harm or suicidal ideation tag will ban a member for 24-hrs.";
  const body = (
    <FormControl fullWidth>
      <CategoryManager categories={props.categories} setCategories={props.setCategories} report={props.report} onAddAction={props.onAddAction}/>
    </FormControl>
  );
  return (
    <CardTemplate title={ title } subtitle={ subtitle } body={ body } />
  );
}